import React from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import api from './api';

const getEnv = () => {
  if (window.location.href.includes('localhost')) {
    return 'local';
  } else if (window.location.href.includes('staging.')) {
    return 'staging';
  } else if (window.location.href.includes('my.')) {
    return 'production';
  } else {
    return 'local';
  }
}

const getAppId = () => {
  if (getEnv() === 'production') {
    return "l231cvpv";
  }


  return "w0zc9abe"
}

class IntercomComponent extends React.Component {
  state = {
    isLoaded: false,
    loadedUserId: undefined,
    loadedTeamId: undefined,
  }


  componentDidMount = async () => {
    await this.loadIntercom();
  }

  componentDidUpdate = async () => {
    await this.loadIntercom();
  }


  getIsChanged = () => {
    
  }


  loadIntercom = async () => {
    if (this.state.isLoaded && (this.state.loadedUserId === this.props.user?._id && this.state.loadedTeamId === this.props.team?._id)) return;

    if(!this.props.user || !this.props.user._id)
      return;

    let token = undefined;

    if (this.props.user) {
      const tokenRes = await api.get('/user/intercomToken')
      if (tokenRes.success) {
        token = tokenRes.token;
      }else{
        return;
      }
    }
   
    Intercom({
      app_id: getAppId(),
      intercom_user_jwt: token,
      session_duration: 3600000, // 1 hour
      company: {
        id: this.props.team?._id,
      },
    });
    this.setState({ isLoaded: true, loadedUserId: this.props.user?._id, loadedTeamId: this.props.team?._id });
  }


  render = () => {
    return null;
  }
}


export default IntercomComponent;